import { uiKitLinkButtonComponent } from 'shared/components/UiKitComponents/UiKitLinkButton/component';
import { uiKitButtonComponent } from 'shared/components/UiKitComponents/UiKitButton/component';

export const buttons = {
  uiKitButton: uiKitButtonComponent,
  uiKitLinkButton: uiKitLinkButtonComponent,
};
